import { BlogCard } from './types';

export const traumaBlogCards: BlogCard[] = [
  {
    title: {
      content:
        "### King's Trauma Team Streaming Success On Netflix - Critical: Between Life and Death",
      styles: {
        h3: 'font-Mulish font-bold text-royal-875 my-3 text-base md:text-lg leading-tight line-clamp-2',
      },
      topicsStyles: {
        h3: 'text-theme-primary text-3xl md:text-4xl my-4 md:my-6 p-2 font-black',
      },
    },
    description: {
      content:
        'The series covers compelling, real-life stories of seriously injured patients and the highly skilled and compassionate...',
      styles: {
        p: 'text-sm md:text-base text-text-default font-medium leading-relaxed mb-3',
      },
    },
    imageUrl: 'king-s-cover-ibrahim.webp',
    slug: 'kings-trauma-team',
    contentType: 'image',
    articleImg: 'eldaly-kings-article.webp',
    topics: {
      title: {
        content: '#### TOPICS:',
        styles: {
          h4: 'text-theme-primary  font-extrabold p-2',
        },
      },
      topics: ['Emergency', 'Trauma & orthopaedic'],
      styles: {
        p: 'p-2 bg-info-500-opac-10 text-teal-450 bg-info-500-soft',
      },
    },
    speciality: 'Trauma & Orthopaedic',
    date: {
      content: '10, Nov 2025',
      iconUrl: '/images/blogs/calendar.svg',
      styles: {
        p: 'text-gray-500 text-xs',
      },
    },
    author: {
      content: "King's College Hospital",
      styles: {
        p: 'text-indigo-650 font-bold text-xs',
        h3: 'text-theme-primary font-black text-2xl md:text-4xl pt-10 pb-4',
      },
    },
  },
  {
    title: {
      content: '### Emergency On Channel 4',
      styles: {
        h3: 'font-Mulish font-bold text-royal-875 my-3 text-base md:text-lg leading-tight line-clamp-2',
      },
      topicsStyles: {
        h3: 'text-theme-primary text-3xl md:text-4xl my-4 md:my-6 p-2 font-black',
      },
    },
    description: {
      content:
        'The series shows the minute-by-minute decisions made by NHS staff across the world-leading London Trauma Network,',
      styles: {
        p: 'text-sm md:text-base text-text-default font-medium leading-relaxed mb-3',
      },
    },
    imageUrl: 'king-s-article-ibrahim.webp',
    articleImg: 'ml4886-inside-kings-issue-4-fin-webs-01.webp',
    slug: 'emergency-on-channel-4',
    contentType: 'image',
    topics: {
      title: {
        content: '#### TOPICS:',
        styles: {
          h4: 'text-theme-primary  font-extrabold p-2',
        },
      },
      topics: ['Emergency', 'Trauma & orthopaedic'],
      styles: {
        p: 'p-2 bg-info-500-opac-10 text-teal-450 bg-info-500-soft',
      },
    },
    speciality: 'Trauma & Orthopaedic',
    date: {
      content: '30, Jul 2025',
      iconUrl: '/images/blogs/calendar.svg',
      styles: {
        p: 'text-gray-500 text-xs',
      },
    },
    author: {
      content: "King's College Hospital",
      styles: {
        p: 'text-indigo-650 font-bold text-xs',
        h3: 'text-theme-primary font-black text-2xl md:text-4xl pt-10 pb-4',
      },
    },
  },
  {
    title: {
      content: '### Smooth Operator',
      styles: {
        h3: 'font-Mulish font-bold text-royal-875 my-3 text-base md:text-lg leading-tight line-clamp-2',
      },
      topicsStyles: {
        h3: 'text-theme-primary text-3xl md:text-4xl my-4 md:my-6 p-2 font-black',
      },
    },
    description: {
      content:
        'LIFE-SAVING surgeon Paul Culpan is set for fame as he stars in a dramatic Netflix medical series.',
      styles: {
        p: 'text-sm md:text-base text-text-default font-medium leading-relaxed mb-3',
      },
    },
    imageUrl: 'smooth-operator.webp',
    slug: 'smooth-operator',
    contentType: 'pdf',
    pdfUrl: 'critical-daily-record-21-7-25.pdf',
    speciality: 'Trauma & Orthopaedic',
    date: {
      content: '10, Nov 2025',
      iconUrl: '/images/blogs/calendar.svg',
      styles: {
        p: 'text-gray-500 text-xs',
      },
    },
    topics: {
      title: {
        content: '#### TOPICS:',
        styles: {
          h4: 'text-theme-primary  font-extrabold p-2',
        },
      },
      topics: ['Trauma & orthopaedic'],
      styles: {
        p: 'p-2 bg-info-500-opac-10 text-teal-450 bg-info-500-soft',
      },
    },
    writtenBy: {
      content: ' Rick Fulton',
      styles: {
        h3: ' text-base md:text-xl',
      },
    },
    author: {
      content: 'Daily Record',
      styles: {
        p: 'text-indigo-650 font-bold text-xs md:whitespace-nowrap',
        h3: ' text-theme-primary font-black text-xl md:text-4xl',
      },
    },
  },
];
